export const GET_ALL_DASHBOARD = "GET_ALL_DASHBOARD";
export const ALL_ASSIGN_PERMISSIONS = "ALL_ASSIGN_PERMISSIONS";
export const ALL_ASSIGN_PREMISES_DETAILS = "ALL_ASSIGN_PERMISSIONS";
export const CREATE_ASSIGN_PERMISSION = "CREATE_ASSIGN_PERMISSION";
export const CREATE_ADD_USERS = "CREATE_ADD_USERS";
export const CREATE_ADD_TENANTS = "CREATE_ADD_TENANTS";
export const CREATE_EDIT_TENANTS = "CREATE_EDIT_TENANTS";
export const CREATE_EDIT_TENANTS_STATUS = "CREATE_EDIT_TENANTS_STATUS";
export const EDIT_UPDATE_USERS = "EDIT_UPDATE_USERS";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_TENANTS = "GET_ALL_TENANTS";
export const FETCH_LOGIN_DATA = "FETCH_LOGIN_DATA";
export const FETCH_SIGNUP_DATA = "FETCH_SIGNUP_DATA";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const CREATE_ROLE = "CREATE_ROLE";
export const UPDATE_STATUS_USERS = "UPDATE_STATUS_USERS";
export const VIEW_USERS = "VIEW_USERS";
export const VIEW_ROLES = "VIEW_ROLES";
export const ASSIGN_PERMISSIONS = "ASSIGN_PERMISSIONS";
export const GETALL_PERMISSION = "GETALL_PERMISSION";
export const ROLE_PERMISSIONS = "ROLE_PERMISSIONS";
export const EDIT_USER = "EDIT_USER";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const All_COUNTS = "All_COUNTS";
